<template>
  <div id="facilitador">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Propietarios
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title class="headline lighten-3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
          >
          </v-text-field>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="propietarios"
          class="elevation-1"
          rows-per-page-text="Filas por página"
          no-data-text="No existen registros"
          no-results-text="Sin resultados"
          page-text="de"
          :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
          v-bind:search="search"
          v-cloak
        >
          <template v-slot:items="props">
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.codigo }}</td>
            <td>{{ props.item.institucioneducativa }}</td>
            <td>{{ props.item.nombre }}</td>
            <td>{{ props.item.carnet }} {{ props.item.complemento }}</td>
            <td>{{ props.item.telefono }}</td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from "../services/general";
import axios from "axios";
export default {
  name: "propietario",
  data() {
    return {
      search: "",
      headers: [
        { text: "Nro", align: "left", sortable: false },
        { text: "Código ", value: "id" },
        { text: "Centro de Capacitación ", value: "institucioneducativa" },
        { text: "Propietario ", value: "nombre" },
        { text: "Cédula de Identidad ", value: "cedula_identidad" },
        { text: "Teléfono ", value: "telefono" },
      ],
      loading: false,
      propietarios: [],
      dparams: {},
      snack: {
        state: false,
        color: 'success',
        mode: '',
        text: ''
      }
    };
  },
  mounted() {
    this.dparams = Service.getParams();
    if (this.dparams && this.dparams.roluser != Service.rol().departamental) {
      this.$router.push({name: 'principal'});
    }
    if (this.dparams != null) {
      this.getPropietarios();
    }
  },
  methods: {
    getPropietarios() {
      this.loading = true;
      axios
        .get(Service.getBase() + 'lista/propietarios', Service.getHeader())
        .then(response => {
          this.loading = false;
          this.propietarios = response.data;
        })
        .catch(error => {
          this.loading = false;
          console.error("Error al cargar registros", error);
        });
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    }
  }
};
</script>